export class VehicleType {
    vehicle_code: string;
    vehicle_desc: string;
    vehicle_icon: string;
}